<header
  [class]="shouldApplyScrolledStyle() ? 'bg-white border-zinc-100' : 'bg-transparent border-white/50'"
  class="fixed top-0 z-50 flex h-14 w-full justify-between border-b py-4 transition duration-300 lg:h-18">
  <nav class="container flex items-center justify-between px-5">
    <!-- 로고 + 연계사이트 드롭다운 -->
    <div class="flex items-center gap-2">
      <a routerLink="/" class="cursor-pointer">
        <img
          [src]="logoData()?.value || '/logo-v2.png'"
          alt="올하우스 로고"
          class="bg-cover bg-center bg-no-repeat w-26 lg:w-32" />
      </a>

      <!-- PC: 드롭다운 버튼 (연계사이트) -->
      <div class="relative hidden lg:block" (mouseenter)="openDropdown()" (mouseleave)="closeDropdown()">
        <button
          type="button"
          class="flex items-center justify-center w-7 h-7 bg-white/10 rounded-full transition-colors duration-200 cursor-pointer"
          [class]="shouldApplyScrolledStyle() ? 'hover:bg-zinc-200' : 'hover:bg-zinc-200'">
          <app-icon
            name="material-symbols:keyboard-arrow-down-rounded"
            class="size-5! transition-transform duration-300"
            [class.rotate-180]="isDropdownOpen()"
            [class]="shouldApplyScrolledStyle() ? 'text-zinc-600' : 'text-zinc-600'" />
        </button>

        <!-- 드롭다운 패널 -->
        @if (isDropdownOpen()) {
        <div class="absolute top-full left-1/2 -translate-x-1/2 pt-3 z-50">
          <div
            class="w-fit bg-white/70 backdrop-blur-md rounded-2xl shadow-lg border border-white/40 overflow-hidden">
            <div class="py-2">
              @for (site of relatedSites; track $index) {
              <a
                [href]="site.url"
                target="_blank"
                rel="noopener noreferrer"
                (click)="closeDropdown()"
                class="flex items-center px-4 py-2.5 text-sm text-zinc-800 hover:bg-zinc-50 hover:text-primary-500 transition-colors duration-150 sb-aggro font-light whitespace-nowrap">
                {{ site.label }}
              </a>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="flex gap-2.5 items-center lg:hidden">
      <button type="button" (click)="onMenuClick()" class="cursor-pointer flex items-center">
        <app-icon
          name="material-symbols:menu-rounded"
          [class]="shouldApplyScrolledStyle() ? 'text-zinc-800' : 'text-zinc-800'"
          class="size-5!" />
      </button>
    </div>

    <!-- lg 이상: 상단 메뉴 -->
    <div class="hidden gap-9 lg:flex">
      @for (item of navItems; track i; let i = $index) {
      <a
        [class]="shouldApplyScrolledStyle() ? 'text-zinc-800' : 'text-zinc-800'"
        class="cursor-pointer sb-aggro font-normal px-4"
        [routerLink]="[item.path]">
        {{ item.label }}
      </a>
      }
    </div>
  </nav>
</header>
